import React from "react";
import { fmtDate } from "@/lib/dates";
import { TrendingUp } from "lucide-react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const CHART_MARGIN = { top: 5, right: 12, left: -18, bottom: 0 };
const AXIS_TICK = { fontSize: 11, fill: "#8a8178" };
const Y_DOMAIN = [0, 100];
const TOOLTIP_STYLE = { borderRadius: 12, border: "1px solid #e7e0d6", fontSize: 12 };
const DOT_CORAL = { r: 3, fill: "#F26B50" };
const ACTIVE_DOT = { r: 5 };
const tooltipFmt = (v) => [`${v}%`, "Score"];
const toSeries = (hist) => (hist || []).map((h) => ({ label: fmtDate(h.date).slice(0, 5), score: h.score }));

export function AssuranceTrend({ history }) {
  if ((history || []).length < 2) return null;
  return (
    <div data-testid="assurance-trend" className="rounded-2xl bg-cream-card border border-cream-deep p-5 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="h-4 w-4 text-brand" />
        <h4 className="font-heading font-bold text-brand text-sm">Assurance trend</h4>
        <span className="text-xs text-muted-foreground ml-auto">Last {history.length} assessments</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <AreaChart data={toSeries(history)} margin={CHART_MARGIN}>
          <defs>
            <linearGradient id="assuranceGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#1E3A5F" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#1E3A5F" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e0d6" vertical={false} />
          <XAxis dataKey="label" tick={AXIS_TICK} axisLine={false} tickLine={false} />
          <YAxis domain={Y_DOMAIN} tick={AXIS_TICK} axisLine={false} tickLine={false} width={46} />
          <Tooltip formatter={tooltipFmt} contentStyle={TOOLTIP_STYLE} />
          <Area type="monotone" dataKey="score" stroke="#1E3A5F" strokeWidth={2.5} fill="url(#assuranceGrad)" dot={DOT_CORAL} activeDot={ACTIVE_DOT} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
